const FOCUS_RING = "#0f172a"
const CENTER_HALO = "#ffffff"

export function drawGraphNode(node, ctx, globalScale, { theme, focused }) {
  const baseRadius = Math.sqrt(Math.max(node.val ?? 4, 1)) * 4
  const radius = node.isCenter ? baseRadius * 1.2 : baseRadius
  const color = node.isCenter ? theme.center : node.color
  const x = node.x ?? 0
  const y = node.y ?? 0

  if (node.isCenter) {
    ctx.beginPath()
    ctx.arc(x, y, radius + 4 / globalScale, 0, 2 * Math.PI, false)
    ctx.fillStyle = CENTER_HALO
    ctx.fill()
  }

  ctx.fillStyle = color
  ctx.strokeStyle = node.isCenter ? theme.center : focused ? FOCUS_RING : color
  ctx.lineWidth = node.isCenter ? 2.5 / globalScale : focused ? 2.5 / globalScale : 1 / globalScale

  drawShapePath(ctx, node.shape, x, y, radius)
  ctx.fill()

  if (node.isCenter || focused) {
    ctx.stroke()
  }
}

export function drawShapePath(ctx, shape, x, y, radius) {
  switch (shape) {
    case "square":
      drawSquare(ctx, x, y, radius)
      break
    case "diamond":
      drawDiamond(ctx, x, y, radius)
      break
    case "triangle":
      drawTriangle(ctx, x, y, radius)
      break
    case "hexagon":
      drawHexagon(ctx, x, y, radius)
      break
    default:
      ctx.beginPath()
      ctx.arc(x, y, radius, 0, 2 * Math.PI, false)
  }
}

function drawSquare(ctx, x, y, radius) {
  ctx.beginPath()
  ctx.rect(x - radius, y - radius, radius * 2, radius * 2)
}

function drawDiamond(ctx, x, y, radius) {
  ctx.beginPath()
  ctx.moveTo(x, y - radius)
  ctx.lineTo(x + radius, y)
  ctx.lineTo(x, y + radius)
  ctx.lineTo(x - radius, y)
  ctx.closePath()
}

function drawTriangle(ctx, x, y, radius) {
  ctx.beginPath()
  ctx.moveTo(x, y - radius)
  ctx.lineTo(x + radius, y + radius * 0.8)
  ctx.lineTo(x - radius, y + radius * 0.8)
  ctx.closePath()
}

function drawHexagon(ctx, x, y, radius) {
  ctx.beginPath()
  for (let i = 0; i < 6; i += 1) {
    const angle = (Math.PI / 3) * i - Math.PI / 6
    const px = x + radius * Math.cos(angle)
    const py = y + radius * Math.sin(angle)
    if (i === 0) ctx.moveTo(px, py)
    else ctx.lineTo(px, py)
  }
  ctx.closePath()
}

export function shapeForNodeType(nodeType) {
  switch (nodeType) {
    case "conference_talk":
    case "speaker":
      return "square"
    case "cfm_lesson":
      return "diamond"
    case "topical_guide_entry":
    case "bible_dictionary_entry":
    case "triple_index_entry":
      return "triangle"
    case "foundational_text":
    case "foundational_text_section":
    case "hymn_text":
      return "hexagon"
    default:
      return "circle"
  }
}
